import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useSavedSearchId } from './SavedSearchStore';

const ALL_SAVED_SEARCHES = {};

type SavedSearchQueryKeyVars = {
    savedSearchId?: number | null;
};

export function getSavedSearchQueryKey(
    vars: SavedSearchQueryKeyVars = ALL_SAVED_SEARCHES,
) {
    return [{ scope: 'savedSearch', ...vars }] as const;
}

export function useSubmitSavedSearch() {
    const queryClient = useQueryClient();
    const { setSavedSearchId } = useSavedSearchId();

    const updateSavedSearch = React.useCallback(
        (id?: number | null) => {
            setSavedSearchId(id);
            queryClient.invalidateQueries({
                queryKey: getSavedSearchQueryKey(),
            });
        },
        [queryClient, setSavedSearchId],
    );

    return { updateSavedSearch };
}
